import { FieldRole, ReportingField } from "../model/types";

/**
 * Which field types each mapping dropdown offers.
 *
 * The field catalog itself is no longer defined here - it arrives from the API with the
 * dataset, because it is whatever meta fields the workspace actually has. This file only
 * holds the type-based filtering, which is module policy rather than workspace data.
 */
export const roleFilters: Record<
  FieldRole,
  (field: ReportingField) => boolean
> = {
  measure: (field) => ["currency", "number"].includes(field.type),
  date: (field) => field.type === "date",
  budgetMonth: (field) => field.type === "singleSelect",
  identity: (field) => ["identity", "text"].includes(field.type),
  dimension: (field) =>
    ["text", "member", "singleSelect", "identity"].includes(field.type),
};

export const fieldsForRole = (
  fields: ReportingField[],
  role: FieldRole,
): ReportingField[] => fields.filter(roleFilters[role]);

export const fieldByUuid = (
  fields: ReportingField[],
  uuid: string,
): ReportingField | undefined => fields.find((field) => field.uuid === uuid);
